/**
 * Timeline v2 - Action Calendar view.
 *
 * A calendar-style "when to do it" view with Day/3-Day/Schedule modes.
 * Inspired by Google Calendar mobile, focusing on per-day planning.
 */

import React from 'react';
import { PlanStep, Participant, PlanRole } from '../../types/generated/graphql';
import { ActionCalendar } from './calendar';

interface TimelineV2ViewProps {
  steps: PlanStep[];
  participants: Participant[];
  roles?: PlanRole[];
  onNavigateToTask: (taskId: string) => void;
  /** Plan facts for anchor date extraction */
  facts?: Record<string, unknown> | null;
}

/**
 * Timeline v2 component - wraps ActionCalendar.
 */
export const TimelineV2View: React.FC<TimelineV2ViewProps> = ({
  steps,
  participants,
  roles = [],
  onNavigateToTask,
  facts,
}) => {
  return (
    <ActionCalendar
      steps={steps}
      participants={participants}
      roles={roles}
      facts={facts}
      onNavigateToTask={onNavigateToTask}
    />
  );
};

export default TimelineV2View;
